import React from "react";
import { FaBriefcase, FaGraduationCap, FaCertificate } from "react-icons/fa";
import { motion } from "framer-motion";

function AboutMe () {

    return (
        <section id="about" className="px-6 py-20 bg-white text-gray-800">
            <h2 className="text-3xl font-bold text-center mb-12 relative">
                About Me
                <div className="w-24 h-1 bg-[#964b00] mx-auto mt-2"></div>
            </h2>

            <div className="grid md:grid-cols-2 gap-10 max-w-6xl mx-auto">
                <div className="space-y-6">
                    <p>
                        I am a QA Engineer with over 2 years of experience in Software Quality Assurance and Software Engineering, with expertise in software development, testing, and delivering reliable solutions.
                    </p>
                    <p>
                        Additionally, I have gained hands-on experience in both web and mobile development through academic group projects and personal initiatives, 
                        further strengthening my practical skills in real-world scenarios.
                    </p>
                    <p>
                        So, I am actively seeking full-time opportunities where I can contribute to impactful, real-world projects and continue growing as a SDET.
                    </p>
                </div>
                <div className="space-y-8">
                    <div className="flex items-start space-x-4">
                        <div className="bg-[#c19a6b] p-3 rounded-full">
                            <FaBriefcase className="text-[#664c28] text-xl" />
                        </div>
                        <div>
                            <h3 className="font-semibold text-lg">Work Experience</h3>
                            <p>
                               Associate Engineer - Quality Assurance - Zuse Technologies (Pvt) Ltd. - <i className="font-semibold">(2025 Nov-Present)</i>
                            </p>
                            <p>
                               Associate Quality Assurance Engineer - ZData Innovations (Pvt) Ltd. - <i className="font-semibold">(2025 Sep-2025 Nov)</i>
                            </p>
                            <p>
                               Trainee Quality Assurance(Automation) - London Stock Exchange Group (LSEG) - <i className="font-semibold">(2024 Jul-2025 Jan)</i>
                            </p>
                            <p>
                                Intern Software Developer - Azend Technologies (Pvt) Ltd. - 
                                <i className="font-semibold">(2022 Aug-2023 Feb)</i>
                            </p>
                        </div>
                    </div>
                    <div className="flex items-start space-x-4">
                        <div className="bg-[#c19a6b] p-3 rounded-full">
                            <FaGraduationCap className="text-[#664c28] text-xl" />
                        </div>
                        <div>
                            <h3 className="font-semibold text-lg">Education</h3>
                            <p>
                               BSc (Hons) in Information Technology, specializing in Software Engineering from 
                               Sri Lanka Institute of Information Technology - SLIIT
                            </p>
                        </div>
                    </div>
                    <div className="flex items-start space-x-4">
                        <div className="bg-[#c19a6b] p-3 rounded-full">
                            <FaCertificate className="text-[#664c28] text-xl" />
                        </div>
                        <div>
                            <h3 className="font-semibold text-lg">Certifications</h3>
                            <p>
                               ISTQB Certified Tester Foundation Level(CTFL) v4.0 - ISTQB
                            </p>
                            <p>
                               C Programming Language Certified Associate - Programming Essentials in C - Cisco Networking Academy
                            </p>
                            <p>Graph Developer Associate - Apollo GraphQL</p>
                            <p></p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-center mt-8">
                <motion.a
                  href="/documents/Nimrekha Weerasinghe-CV(1).pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-transparent hover:bg-[#c19a6b] text-black font-semibold hover:text-black inline-block px-12 py-3 border border-[#987654] hover:border-transparent rounded-full"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.6, duration: 1 }}>
                    View My CV
                </motion.a>
            </div>
        </section>
    )
}

export default AboutMe;